<script setup lang="ts">
import {onMounted, ref} from 'vue'

const emit = defineEmits<{
  verified: [token: string]
}>()

interface TurnstileApi {
  render: (el: HTMLElement, options: Record<string, unknown>) => void
}

declare global {
  interface Window {
    turnstile?: TurnstileApi
  }
}

const config = useRuntimeConfig()
const siteKey = config.public.turnstileSiteKey
const container = ref<HTMLElement | null>(null)

function renderWidget(): void {
  if (!window.turnstile || !container.value) {
    return
  }
  window.turnstile.render(container.value, {
    sitekey: siteKey,
    callback: (token: string) => emit('verified', token),
    'error-callback': () => emit('verified', ''),
    'expired-callback': () => emit('verified', '')
  })
}

onMounted(() => {
  // 未設定 site key：略過驗證（後端對應 fail-open），直接視為通過。
  if (!siteKey) {
    emit('verified', '')
    return
  }
  if (window.turnstile) {
    renderWidget()
    return
  }
  const script = document.createElement('script')
  script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
  script.async = true
  script.defer = true
  script.onload = renderWidget
  document.head.appendChild(script)
})
</script>

<template>
  <div ref="container"></div>
</template>
